import { render, staticRenderFns } from "./turaltpaketislem.vue?vue&type=template&id=6595ee05&"
import script from "./turaltpaketislem.vue?vue&type=script&lang=js&"
export * from "./turaltpaketislem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports